import type { SeoFaqItem } from "./seo.types";
export function reviewedFaq(faq: SeoFaqItem[]): SeoFaqItem[] {
  return faq.map((f) =>
    /budget|kostar|pris|\bkr\b|\btkr\b|sek/i.test(f.q + " " + f.a)
      ? {
          ...f,
          a: "Ni får ett samlat offertpris före bokning. Godkända grundpriser omfattar beskriven utrustning, ordinarie personal, planering, rigg, nedtagning och stämningsljus. Inkluderade delar debiteras inte igen. Extra arbete utanför upplägget debiteras bara efter godkännande i förväg, med 650 kr exkl. moms per faktisk persontimme. Transport: 160 kr exkl. moms per faktiskt körd svensk mil från Kungsbacka; alla körsträckor räknas. Mario Kart Cup och Racing Grand Prix har inget fastställt paketpris; omfattning och pris fastställs efter kontroll.",
        }
      : f,
  );
}
